import accordion_images from "./accordion_images";
import { isNotEmptyOrNull } from "../common-utils";

export const TaskStatus = (val) => {
  if (val === "notStarted") {
    return "Not Started";
  } else if (val === "inProgress") {
    return "In Progress";
  } else if (val === "completed") {
    return "Completed";
  } else {
    return val;
  }
};

export const getTaskType = (val) => {
  if (val === "guidedPractise" || val === "guidedPractice") {
    return "Guided Practice";
  } else if (val === "learnSubtopic" || val === "learn") {
    return "Learn";
  } else if (val === "learnPrerequisite" || val === "preRequisite") {
    return "Prerequisite";
  } else if (val === "assessment") {
    return "Assessment Practice";
  } else {
    return val;
  }
};

export const getTaskTypeIcons = (val) => {
  switch (val) {
    case "guidedPractise":
      return accordion_images.practiceColor;
    case "learnSubtopic":
      return accordion_images.learnColor;
    case "learnPrerequisite":
      return accordion_images.practiceColor;
    case "assessment":
      return accordion_images.assessmentColor;
    case "experientialLearning":
      return accordion_images.learnColor;
    default:
      return accordion_images.assessmentColor;
  }
};

export const ProgressStatusIcons = (taskType, taskStatus) => {
  if (taskStatus === "notStarted") {
    switch (taskType) {
      case "learnSubtopic":
        return accordion_images.learnHighlight;
      case "guidedPractise":
        return accordion_images.practiceHighlight;
      case "assessment":
        return accordion_images.assessmentHighlight;
      case "learnPrerequisite":
        return accordion_images.practiceHighlight;
      default:
        return accordion_images.assessmentHighlight;
    }
  } else if (taskStatus === "inProgress" || taskStatus === "completed") {
    return getTaskTypeIcons(taskType);
  }
};

export const onClickSubtopic = (
  isunlocked = false,
  isExperientialLearning = false,
  isChapterEndAssessment = false,
  isCustomAssessment = false,
  isPrerequisite = false
) => {
  if (isPrerequisite && !isChapterEndAssessment) {
    return "Prerequisite";
  } else if (
    isunlocked &&
    !isExperientialLearning &&
    !isChapterEndAssessment &&
    !isPrerequisite
  ) {
    return "subtopic";
  } else if (isunlocked && isExperientialLearning && !isChapterEndAssessment) {
    return "experientialLearning";
  } else if (isunlocked && isChapterEndAssessment && !isExperientialLearning) {
    return "chapterEndAssessment";
  } else if (
    isunlocked &&
    isCustomAssessment &&
    !isExperientialLearning &&
    !isChapterEndAssessment
  ) {
    return "customAssessment";
  }
  return null;
};

//Function to open the subtopic and display the subtopic tasks content
export const showAccordionSubtopicContent = (
  updatesSubtopicId,
  openSubtopicId,
  subtopicId,
  isChapterEndAssessment = false,
  isAdvanced = false,
  isAdvancedChapterEndAssessment = false,
  isProficient = false,
  isProficientChapterEndAssessment = false,
  isUpdatesDisplayed
) => {
  if (isNotEmptyOrNull(updatesSubtopicId)) {
    return (
      isUpdatesDisplayed &&
      openSubtopicId === updatesSubtopicId &&
      openSubtopicId === subtopicId
    );
  } else if (isChapterEndAssessment) {
    return (
      openSubtopicId === subtopicId &&
      ((isAdvanced && isAdvancedChapterEndAssessment) ||
        (isProficient && isProficientChapterEndAssessment))
    );
  } else {
    return openSubtopicId === subtopicId;
  }
};

export const selectedSubtopicSkeleton = (
  selectedSubtopic,
  selectedTopic,
  taskType
) => {
  const baseTaskAttributes = {
    curriculumName: "CBSE",
    topicMasterUuid: selectedTopic?.topic?.topicMasterUuid || "",
    topicName: selectedTopic?.topic?.topicInfo?.name || "",
    subtopicId: selectedSubtopic?.subtopicId || "",
    subtopicName: selectedSubtopic?.subtopicInfo?.name || "",
    subtopicMasterUuid: selectedSubtopic?.subtopicMasterUuid || "",
    subjectName: selectedTopic?.topic?.topicInfo?.subject_name || "",
    gradeName: "",
    taskMode: "",
    chapterEndAssessment: selectedSubtopic?.isChapterEndAssessment || false,
    proficiencyLevel: selectedSubtopic?.isAdvanced
      ? "advanced"
      : "proficient",
    experientialLearning: {},
  };

  if (taskType === "assessment" && selectedTopic?.topic?.topicInfo?.topic_features?.Handwriting
        ?.is_enabled) {
    baseTaskAttributes.handwritingEnabled =
      selectedTopic?.topic?.topicInfo?.topic_features?.Handwriting
        ?.is_enabled;
  }

  return {
    _id: "",
    taskId: "",
    userId: "",
    taskName: "",
    description: "",
    taskType: taskType,
    taskAttributes: baseTaskAttributes,
    taskStatus: "",
    schoolId: "",
    gradeId: "",
    subjectId: selectedTopic?.subject?.subjectMasterUuid || "",
    topicId: selectedTopic?.topic?.topicId || "",
    academicYearId: "",
    sectionId: "",
    dueDate: null,
    teacherId: null,
    unAnsweredQuestions: [],
    createdBy: "",
    curriculumId: "38416",
    __v: 0,
    createdAt: "",
    updatedAt: "",
    journeyId: "",
    startedAt: "",
  };
};

export const backUpObjectCreation = (selectedSubTopic) => {
  return {
    subjectMasterUuid: selectedSubTopic?.subjectId || "",
    subjectId: selectedSubTopic?.subjectId || "",
    subjectName: selectedSubTopic?.taskAttributes?.subjectName || "",
    topicMasterUuid: selectedSubTopic?.taskAttributes?.topicMasterUuid || "",
    topicId: selectedSubTopic?.topicId || "",
    topicName: selectedSubTopic?.taskAttributes?.topicName || "",
    subtopicMasterUuid:
      selectedSubTopic?.taskAttributes?.subtopicMasterUuid || "",
    subtopicId: selectedSubTopic?.taskAttributes?.subtopicId || "",
    subtopicName: selectedSubTopic?.taskAttributes?.subtopicName || "",
    chapterEndAssessment:
      selectedSubTopic?.taskAttributes?.chapterEndAssessment || false,
    proficiencyLevel: selectedSubTopic?.taskAttributes?.proficiencyLevel || "",
    experientialLearning:
      selectedSubTopic?.taskAttributes?.experientialLearning || {},
    taskType: selectedSubTopic?.taskType || "",
    journeyId: selectedSubTopic?.journeyId || "",
    taskId: selectedSubTopic?._id || "",
    successObject: {
      isTaskCompleted: false,
      percentage: 0,
      emotionalMessageCode: 0,
    },
    question_id:"",
    isOCR: false,
  };
};
